export const getUserInitial = (contactName?: string) => {
  if (!contactName) return '';

  return contactName
    .trim()
    .split(' ')
    .slice(0, 2) // Take only the first two names
    .map((word) => word.charAt(0)) // Take first character
    .join('')
    .toUpperCase();
};
